

























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import Icon, { IconEnum } from '@/shared/components/icon.component.vue';

export enum TextareaPredefinedStyle {
  Simple = 'textarea--simple-style',
  ClearButton = 'textarea--clear-button-style',
  OnlyBorder = 'textarea--only-border-style',
}

@Component({
  components: {
    Icon,
  },
})
export default class TextArea extends Vue {
  @Prop() private textAreaValue!: string;
  @Prop() private placeholder!: string;
  @Prop({ default: false }) private readOnly!: boolean;
  @Prop({ default: false }) private squared!: boolean;
  @Prop() private maxHeight!: number;
  @Prop() private minHeight!: number;
  @Prop({ default: false }) private textareaError!: boolean;
  @Prop({ default: TextareaPredefinedStyle.Simple })
  private textareaPredefinedStyle!: TextareaPredefinedStyle;

  private content: string = '';
  private textareaHeight: string = '';
  private iconEnum = IconEnum;

  @Watch('textAreaValue')
  public onTextAreaValueValueChanged(newVal: string, oldVal: string) {
    this.content = newVal;
  }

  private created() {
    this.content = this.textAreaValue;
  }

  private mounted() {
    this.resize();
    this.textareaHeight = '26px';
  }

  private updated() {
    this.resize();
  }

  get showClearIcon() {
    return (
      this.textareaPredefinedStyle === TextareaPredefinedStyle.ClearButton &&
      !this.readOnly
    );
  }

  private handleInput(e: any) {
    this.resize();
    this.$emit('input', this.content);
  }

  private handleClick() {
    this.$emit('click');
  }

  private clearTextarea() {
    if (!this.readOnly) {
      this.$emit('clear');
    }
  }

  private resize() {
    const textarea = this.$refs.textarea as HTMLElement;
    textarea.style.setProperty('height', 'auto');
    let contentHeight = textarea.scrollHeight-8;
    if (this.minHeight && contentHeight < this.minHeight) {
      contentHeight = this.minHeight;
    }
    if (this.maxHeight && contentHeight > this.maxHeight) {
      contentHeight = this.maxHeight;
    }
    const heightVal = contentHeight + 'px';
    textarea.style.setProperty('height', heightVal);
    this.textareaHeight = heightVal;
  }
}
